import request from "@/utils/request";
// 邮件注册

// 发送注册认证邮件
export const sendRegisterEmail = data => {
	return request({
		url: "/sendRegisterEmail",
		method: "POST",
		data,
	});
};
